/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect } from 'react';
import Table from '../../../../../components/common/table/table';
import { AnimalEventAnimal } from '../../../../../interfaces/animal-event';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import TableVerticalSizeFixer from '../../../../../components/common/table/table-vertical-size-fixer/table-vertical-size-fixer';

interface Props {
  animals: AnimalEventAnimal[];
  removeRow?: (index: number, data: AnimalEventAnimal[]) => void;
  eventType: string;
  showRemove: boolean;
}

function FormTable({ animals, removeRow, showRemove }: Props) {
  const { getValues, setValue } = useFormContext();

  useEffect(() => {
    const products = getValues('products');

    setValue('animals', animals);
    const animalsData = getValues('animals');
    const days = getValues('days');

    if (products) {
      products.forEach((product, idx) => {
        product.barns.forEach((barn, barnIdx) => {
          if (barn.amount_for_one) {
            const productAmountTotal = isNaN(barn.amount_for_one)
              ? null
              : !!days
              ? String(barn.amount_for_one * animalsData.length * days)
              : String(barn.amount_for_one * animalsData.length);
            setValue(
              `products.${idx}.barns.${barnIdx}.product_amount_total`,
              productAmountTotal
            );
          }
          if (barn.product_amount_total) {
            const amountForOne = isNaN(barn.product_amount_total)
              ? null
              : !!days
              ? String(barn.product_amount_total / (animalsData.length * days))
              : String(barn.product_amount_total / animalsData.length);
            setValue(
              `products.${idx}.barns.${barnIdx}.amount_for_one`,
              amountForOne
            );
          }
        });
      });
    }
  }, [animals, getValues]);
  const { t } = useTranslation();

  const transKeyPrefix = 'pages.livestock.animals_and_events.';
  const tp = useCallback(
    (key: string, params?: { [key: string]: string | number }) =>
      t(transKeyPrefix.concat(key), params),
    [t]
  );

  return (
    <TableVerticalSizeFixer>
      <Table<AnimalEventAnimal>
        data={animals}
        keyAccessor="id"
        onRemove={removeRow}
        filteredTotalsParams={{
          recordName: 'pages.livestock.animals_and_events.events.table_title',
          fullText: { tp, key: 'events.table_title' },
        }}
        paginate={false}
        showRemove={showRemove}
        columns={[
          {
            accessor: 'animal_id',
            header: tp('events.grazing.id'),
            sortable: false,
            className: 'animal_id',
          },
          {
            accessor: 'name',
            header: tp('events.grazing.name'),
            sortable: false,
            className: 'name',
          },
          {
            accessor: 'breed_code',
            header: tp('events.grazing.breed'),
            sortable: false,
            className: 'breed_code',
          },
        ]}
      />
    </TableVerticalSizeFixer>
  );
}

export default FormTable;
